import React, { useMemo, useState } from 'react'
import { FormProvider, useFieldArray, useForm, useWatch } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { Input } from '@/components/Form'
import { Box, Button, Flex, Heading } from '@chakra-ui/react'

import useFrameAgreement from '@/features/frameAgreements/useFrameAgreement'
import { toast } from 'react-toastify'
import EditableTable from '@/components/Table/EditableTable'
import { createColumnHelper } from '@tanstack/react-table'
import { InputCell } from '@/components/Table/components/Cell'
import { DeleteButton } from '@/components/Elements/Button'
import { getFrameAgreementDetailTableColumns } from '@/features/frameAgreements/constants/frameAgreementTableColumns'

//API

//Constant

const CreateFrameAgreementPage = () => {
  //State
  const methods = useForm({ defaultValues: { details: [], name: '' } })
  const navigate = useNavigate()
  const { useCreateFrameAgreement } = useFrameAgreement()
  const createFrameAgreement = useCreateFrameAgreement()
  const columnHelper = createColumnHelper()
  const frameAgreementDetails = useWatch({ name: 'details', control: methods.control })
  const { append: appendFrameAgreementDetail, remove: removeFrameAgreementDetail } = useFieldArray({
    name: 'details',
    control: methods.control,
  })

  const handleAddRow = () => {
    appendFrameAgreementDetail({
      description: '',
      unit: '',
      rate: 0,
      discountRate_1: 0,
      discountRate_2: 0,
      discountRate_3: 0,
      remark: '',
    })
  }

  const handleRemoveRow = (index) => {
    removeFrameAgreementDetail(index)
  }

  const handleUpdateFrameAgreementDetails = (rowIndex, columnId, value) => {
    methods.setValue(`details.${rowIndex}.${columnId}`, value, { shouldDirty: true })
  }

  const onSubmit = async (data) => {
    try {
      const res = await createFrameAgreement.mutateAsync({
        ...data,
      })
      if (res?.data?._id) {
        navigate(`/admin/frameAgreements/${res?.data?._id}`)
      }
    } catch (err) {
      toast.error(err?.message ?? '')
    }
  }

  const columnDef = getFrameAgreementDetailTableColumns({ handleRemoveRow })
  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
          <Flex p={5} borderBottom="1px solid #d8dbe0">
            <Heading> Create Frame Agreement </Heading>
          </Flex>
          <Box p="5">
            <Flex direction={'column'} gap="3">
              <Input name="name" label="Name" isRow isRequired />

              <Flex>
                <Button onClick={handleAddRow} colorScheme="green" isDisabled={false}>
                  Add Row
                </Button>
              </Flex>

              <EditableTable
                columnDef={columnDef}
                data={frameAgreementDetails}
                disabled={false}
                tableWidth={'100%'}
                updateData={handleUpdateFrameAgreementDetails}
              />
            </Flex>

            <Button mt="6" colorScheme="blue" type="submit">
              Save
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  )
}

export default CreateFrameAgreementPage
